'use strict';
import React from 'react';
import contractorAction from '../../actions/contractorAction';
import contractorStore from '../../stores/contractorStore';
import ModalCondo from './modalCondo';
class ContractorCondoForm extends React.Component {
    constructor(props) {
        super(props);
        this.handleEditService = this.handleEditService.bind(this);
        this.handleNewCondo = this.handleNewCondo.bind(this);
        this.handleNewService = this.handleNewService.bind(this);
        this.handleRemoveCondo = this.handleRemoveCondo.bind(this);
        this.handleRemoveService = this.handleRemoveService.bind(this);
        this.handleToggle = this.handleToggle.bind(this);
        this.shouldModalClose = this.shouldModalClose.bind(this);

        this.callBack = this.callBack.bind(this);
        this.state = {
            modalClose: false,
            title: "",
            action: "",
            mcst: "",
            index: "",
        };
    }
    static defaultProps = {
        mthTxt: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        statusTxt: ["Active", "In-Active", "Terminated", "Ad hoc"],

    };
    callBack(value1, value2, value3, value4, value5, value6, value7, value8) {
        if (this.state.action == 0) {
            contractorAction.addCondo({ mcst: value1, condoName: value2 });
        } else if (this.state.action == 1) {
            contractorAction.addService({
                mcst: this.state.mcst, contract: {
                    service: value1, description: value2,
                    remark: value3, amount: value4, contractStartDate: value5, contractEndDate: value6,
                    lastVisit: value7, status: value8
                }
            });
        } else if (this.state.action == 2) {
            contractorAction.removeCondo({ mcst: this.state.mcst });
        } else if (this.state.action == 3) {
            contractorAction.editService({
                mcst: this.state.mcst, index: this.state.index, contract: {
                    service: value1,
                    description: value2, remark: value3, amount: value4, contractStartDate: value5,
                    contractEndDate: value6, lastVisit: value7, status: value8
                }
            });
        } else {
            contractorAction.removeService({ mcst: this.state.mcst, index: this.state.index });
        }
        this.shouldModalClose(false);
    }

    handleToggle(e) {
        let index = parseInt(e.currentTarget.getAttribute('data-index'));
        contractorAction.shouldListShow(index);
    }
    handleNewService(e) {
        e.preventDefault();
        e.stopPropagation();
        let action = 1;
        let title = "Add New Service";
        let mcst = e.target.getAttribute("data-mcst");
        this.setState({
            action: action, title: title, mcst: mcst, modalClose: true
        });
    }
    handleRemoveService(e) {
        let action = 4;
        let title = "Remove Service";
        let mcst = e.target.getAttribute("data-mcst");
        let index = parseInt(e.target.getAttribute("data-index"));
        this.setState({
            action: action, title: title, mcst: mcst, index: index, modalClose: true
        });
    }
    handleRemoveCondo(e) {
        e.preventDefault();
        e.stopPropagation();
        let action = 2;
        let title = "Remove Estate";
        let mcst = e.target.getAttribute("data-mcst");
        this.setState({
            action: action, title: title, mcst: mcst, modalClose: true
        });
    }
    handleEditService(e) {
        let action = 3;
        let title = "Edit Service";
        let mcst = e.target.getAttribute("data-mcst");
        let index = parseInt(e.target.getAttribute("data-index"));
        this.setState({
            action: action, title: title, mcst: mcst, index: index, modalClose: true
        });
    }
    handleNewCondo(e) {
        let action = 0;
        let title = "Add Estate";
        this.setState({
            action: action, title: title, modalClose: true
        });
    }
    shouldModalClose(data) {
        this.setState({
            modalClose: data
        });
    }
    generateDateFormat(date) {
        if (date) {
            return (
                date.getDate() + "-" + this.props.mthTxt[date.getMonth()] + "-" + date.getFullYear()
            );
        }
    }

    renderDetail(condo) {

        let content = condo.contract.map((detail, index) => {
            let contractStartDate = detail.contractStartDate ? this.generateDateFormat(new Date(detail.contractStartDate)) : "";
            let contractEndDate = detail.contractEndDate ? this.generateDateFormat(new Date(detail.contractEndDate)) : "";
            let lastVisit = detail.lastVisit ? this.generateDateFormat(new Date(detail.lastVisit)) : "";
            return (
                <li key={index}>
                    <div className="ct-li-rev" data-index={index} data-mcst={condo.mcst} onClick={this.handleRemoveService}>X</div>
                    <div className="ct-li-group">
                        <label>Service:</label>
                        <div className="ct-li-ct">{detail.service}</div>
                    </div>
                    <div className="ct-li-group">
                        <label>Description:</label>
                        <div className="ct-li-ct">{detail.description}</div>
                    </div>
                    <div className="ct-li-group">
                        <label>Last Visit:</label>
                        <div className="ct-li-ct">{lastVisit ? lastVisit : "--"}</div>
                    </div>
                    <div className="ct-li-group">
                        <label>Status</label>
                        <div className="ct-li-ct">{typeof detail.status == 'number' ? this.props.statusTxt[detail.status] : "--"}</div>
                    </div>
                    <div className="ct-li-group">
                        <label>Remark:</label>
                        <div className="ct-li-ct">{detail.remark ? detail.remark : "--"}</div>
                    </div>
                    <div className="ct-li-group">
                        <label >Contract Start Date:</label>
                        <div className="ct-li-ct">{contractStartDate ? contractStartDate : "--"}</div>
                    </div>
                    <div className="ct-li-group">
                        <label >Contract End Date:</label>
                        <div className="ct-li-ct">{contractEndDate ? contractEndDate : "--"}</div>
                    </div>
                    <div className="ct-li-group">
                        <label>Amount (SGD):</label>
                        <div className="ct-li-ct">{detail.amount ? "$" + detail.amount : "--"}</div>
                    </div>
                    <button className="ct-li-edit btn btn-default btn-xs" data-index={index} data-mcst={condo.mcst} onClick={this.handleEditService}>Edit</button>
                </li>
            );
        });
        return (
            <ul className={"ct-cul " + (condo.shouldListShow ? "ct-show" : "ct-hide")}>
                {content}
            </ul>
        );
    }
    renderCondo() {
        let s = this.props.contractor;

        return s.contracts.map((condo, index) => {
            return (
                <div key={index}>
                    <div className="ct-cli" data-index={index} key={index} onClick={this.handleToggle}>
                        <span className={"ct-icon glyphicon " + (condo.shouldListShow ? "glyphicon-minus" : "glyphicon-plus")}></span>
                        <div className="ct-cn" data-mcst={condo.mcst} data-condoname={condo.condoName}>{condo.condoName + " (" + condo.mcst + ")"}</div>
                        <div className="ct-btn-grp">
                            <button className="btn btn-xs btn-default" data-mcst={condo.mcst} onClick={this.handleNewService}>Add</button>
                            <button className="btn btn-xs btn-danger" data-mcst={condo.mcst} onClick={this.handleRemoveCondo}>Remove</button>
                        </div>
                    </div>
                    {this.renderDetail(condo)}
                </div>
            );
        })
    }

    render() {
        let modal = "";
        if (this.state.modalClose) {
            modal = (<ModalCondo
                shouldModalClose={this.shouldModalClose}
                modalClose={this.state.modalClose}
                title={this.state.title}
                action={this.state.action}
                condos={this.props.condos}
                index={this.state.index}
                mcst={this.state.mcst}
                contracts={this.props.contractor.contracts}
                callBack={this.callBack}
            />);
        }
        return (
            <div>
                {modal}
                <div className="condoList">
                    <h4><b>Managing Estate</b></h4>
                    <button type="button" className="btn btn-default"
                        data-index="0" onClick={this.handleNewCondo} data-id={this.props.contractor._id}>Add New Estate</button>
                    {this.renderCondo()}
                </div>
            </div>
        );
    }
}
export default ContractorCondoForm;


// WEBPACK FOOTER //
// ./app/setComponents/contractorComponents/contractorCondoForm.js